export const pageview = (url) => {
    if (window.gtagReady && typeof window.gtag === 'function') {
        window.gtag('config', 'G-C95D624RX4', {
            page_path: url,
        });
    } else {
        console.warn("gtag is not ready or defined");
    }
};